import { camelToSnake, snakeToCamel } from "caseparser";

import { api } from "@/app/app.api";

import { RequestMethod } from "@/shared/utils/RequestMethod";

export const trainingApi = api
  .enhanceEndpoints({ addTagTypes: [] })
  .injectEndpoints({
    overrideExisting: false,
    endpoints: (builder) => ({
      updateTraining: builder.mutation({
        query: ({
          userId,
          trainingProgressId,
          id,
          position,
          plan,
          training,
          objective,
          weeks,
          download,
          searchable,
          name,
        }) => ({
          url: `api/v3/training/${id}`,
          method: RequestMethod.PUT,
          body: camelToSnake({
            userId,
            trainingProgressId,
            position,
            training,
            plan,
            objective,
            weeks,
            download,
            searchable,
            name,
          }),
        }),
        transformResponse: (response: any) => snakeToCamel(response.data),
      }),
    }),
  });

export const { useUpdateTrainingMutation } = trainingApi;
